import { getFileLink } from 'legacy/lut/helpers/files/getFileLink'

import { FormId } from 'clickNgo/configs/formId'
import { IAttachment, IFileData } from 'clickNgo/models/file'

export const mapLegalAttachmentsFromFileData = (files: IFileData[]): IAttachment[] => {
  return files.map<IAttachment>((file) => {
    const entryId = file.entryId
    const uid = file.uid
    const formId = FormId.LEGAL_ATTACHMENTS
    const fileName = file.fileName
    const fieldName = 'Attachment'
    const link = getFileLink({ uid, entryId, formId, fileName, fieldName })

    return {
      entryId,
      formId,
      fileName,
      fieldName,
      link,
      uid,
    }
  })
}
